import { MediaType } from '@confluence/graphql/entry-points/MediaType';
import { throwErrorWithResponse } from '@confluence/graphql/entry-points/throwErrorWithResponse';
import { useExperimentalMutation } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalMutation';
import { BadStatusError } from '@confluence/network';

import type {
	RevertContentMutation,
	RevertContentMutationVariables,
} from './__types__/RevertContentMutation';

export const useExperimentalRevertContentMutation = ({
	onCompleted,
}: {
	onCompleted?: (data: RevertContentMutation) => void;
} = {}) => {
	return useExperimentalMutation<
		RevertContentMutation,
		RevertContentMutationVariables,
		RevertContentMutationResponse
	>({
		url: (variables) => {
			if (!variables.contentId) {
				throw new Error('contentId is missing');
			}
			return `/wiki/rest/collab/1.0/content/${variables?.contentId}/changes/unpublished`;
		},
		method: 'DELETE',
		headers: {
			'Content-Type': MediaType.JSON,
		},
		parseResult: () => ({ experimentalRevertContent: true }),
		onCompleted,
		onError: (error) => {
			if (error instanceof BadStatusError) {
				return throwErrorWithResponse(
					new Error(`Failed to revert or delete draft: ${error}`),
					error?.response,
				);
			}
		},
	});
};

type RevertContentMutationResponse = {};
